import { parseInt, isElement, forEach } from "lodash";

import { subscribe } from '../../01-helpers/event-manager';

import { VOTE_SUBMITTED } from '../../02-const/event-names';

const moduleName = "vote-indicator",
    selectors = {
        base: `.js-${moduleName}`
    },
    vote = {
        photoId: 0
    },
    data = {
        photoId: "photo",
        voteCount: "voteCount"
    };

export default class VoteIndicator {

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }

    //========= Event Handling ==========//

    _onVoteSubmitted(event) {
        let submittedVote = event.detail;
        vote.photoId = this.baseElement.dataset[data.photoId];

        if (vote.photoId == submittedVote.photoId)
        {
            let voteCount = parseInt(this.baseElement.dataset[data.voteCount]);

            voteCount++;
            
            this.baseElement.innerHTML = voteCount;
        }
    }

    //===================================//

    //========= Initialization ==========//

    _configure(baseElement) {
        this.baseElement = baseElement;
    }

    _setup() {
        subscribe(VOTE_SUBMITTED, (event) => this._onVoteSubmitted(event));
    }

    //===================================//
}

const initVoteIndicator = () => {
    forEach(document.querySelectorAll(selectors.base), (element) => {
        new VoteIndicator(element);
    });
};

initVoteIndicator();